import { FeedArticleItems } from "@routes/Article/utils/types";
import { USFPodcastSchemaProps } from "@sphtech/web2-seo-schema";
import { BT_PODCASTS_KEYWORD } from "@src/app/routePaths";
import { getUrlPathFromAbsoluteUrl } from "@src/app/routes/Article/utils/helpers";

/**
 * Helper function to get the article JSONLD.
 * @param article The article object.
 * @returns {schemaType}
 */
export const getPodcastArticleSchemaProperties = (
  article: FeedArticleItems
): USFPodcastSchemaProps => {
  const { urlPath, title, publishTime, blurb, tags } = article;
  const podcastTag = tags?.find((tag) =>
    BT_PODCASTS_KEYWORD.some(
      ({ url }) => url === getUrlPathFromAbsoluteUrl(tag.urlPath)
    )
  );

  return {
    name: title,
    contentUrl: urlPath,
    datePublished: publishTime,
    description: blurb,
    ...(podcastTag
      ? { seriesName: podcastTag.name, seriesUrl: podcastTag.urlPath }
      : {}),
  };
};
